// @ts-check
import { useSessionCtx } from "utils";

/**
 * useFlowConfig
 * @description
 * A helper hook that grabs the necessary key from session and null checks
 * some of the possible values that can be found in the flow config.
 */
export const useFlowConfig = () => {
  const { sessionCtx } = useSessionCtx();

  if (!sessionCtx) {
    return {};
  }

  const { flowConfig } = sessionCtx;
  const hideExitButtons = flowConfig?.hideExitButtons || false;

  return {
    ...flowConfig,
    hideExitButtons,
  };
};
